import api from "../api/axios";

/* ---------- BRANCHES ---------- */
export const getBranches = () => api.get("api/branches/get-branch");

export const createBranch = (data) => api.post("api/branches/add-branch", data);
